<div
  class="bg-(--labresultcard-background) rounded-(--labresultcard-border-radius)"
  [class]="hasBorder() ? 'border border-(--labresultcard-border-color)' : ''"
>
  <!-- Title Section -->
  @if (hasTitle()) {
    <button
      type="button"
      class="flex items-center gap-2 w-full px-(--labresultcard-padding-x) py-(--labresultcard-padding-y) border-b border-b-(--labresultcard-border-color) cursor-pointer bg-transparent"
      (click)="onTitleClick()"
    >
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: titleConfig() }"
      />
      <app-dynamic
        componentName="SvgIcon"
        [props]="{ name: 'caret-right', size: '16', color: 'var(--labresultcard-chevron-color)' }"
      />
    </button>
  }

  <!-- Content Section -->
  <div class="flex items-center gap-2 px-(--labresultcard-padding-x) py-(--labresultcard-padding-y)">
    <div class="flex-1 flex flex-col gap-1">
      <div class="flex items-center gap-1">
        <app-dynamic
          componentName="DynamicText"
          [props]="{ config: primaryTextConfig() }"
        />
        <app-dynamic
          componentName="DynamicText"
          [props]="{ config: secondaryTextConfig() }"
        />
      </div>
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: supportingTextConfig() }"
      />
    </div>
    <app-dynamic
      componentName="Chip"
      [props]="{ config: chipConfig() }"
    />
  </div>
</div>
